import { loadAcalogAPI } from "../acalogAPI";

export function processAosCourses(module, mapContainer) {
  let overviewDataContainer = module.find(".js-aosCourses");
  overviewDataContainer.html(mapContainer);

  loadAcalogAPI(fetchCourseDataAndInject, true);
}

function handleAcalogLinkClick(selector, getContainerCallback) {
  // Hidden due to task request
  // $(document).on("click", selector, function (e) {
  //   e.preventDefault();
  //
  //   const $link = $(this);
  //   const $container = getContainerCallback($link);
  //
  //   $('.acalog-permalink-container, .acalog-program-core-course-body').hide();
  //
  //   const catalogCourseUrl = $container.attr("data-acalog-ajax");
  //
  //   // Construct the API URL
  //   const apiUrl = `https://catalog.sunywcc.edu/widget-api/${catalogCourseUrl}`;
  //
  //   if ($container.html()) {
  //     $container.show();
  //     return;
  //   }
  //
  //   $.ajax({
  //     url: apiUrl,
  //     method: "GET",
  //     beforeSend: function () {
  //       $container.html(
  //         "Loading... Depending on your internet speed, it could take up to 30 seconds...please be patient."
  //       );
  //       $container.show();
  //     },
  //     success: function (data) {
  //       const content = `
  //         <h1 class="acalog-course-title">${data.prefix} ${data.code}&nbsp;-&nbsp;${data.name}</h1>
  //         <div class="acalog-course-body">${data.body}</div>
  //         <a href="#" class="acalog-close" aria-label="Close acalog">Close</a>
  //       `;
  //
  //       $container.html(content);
  //     },
  //     error: function (xhr, status, error) {
  //       console.error("Error fetching course data:", error);
  //       $container.html("Error loading course data. Please try again.");
  //     },
  //   });
  // });
}

function fetchCourseDataAndInject() {
  handleAcalogLinkClick(
    ".js-aosProgramCourse .acalog-permalink a",
    function ($link) {
      return $link.closest(".acalog-permalink").find(".acalog-permalink-container");
    }
  );

  handleAcalogLinkClick(
    ".js-aosProgramCourse .acalog-program-core-course a",
    function ($link) {
      return $link.next().find(".acalog-program-core-course-body");
    }
  );

  // Handle close button clicks using event delegation
  $(document).on("click", ".acalog-close", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this)
      .closest(".acalog-permalink-container").hide();
  });
}